import { Breadcrumbs, Container, Divider, Heading, Hidden } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import { canDisplayMetaInfo, MetaInfo } from '../MetaInfo/MetaInfo'

import type { Article, PartialCategory, PartialSection } from '@doist/help-center-utils'
import type { User } from 'types/user'

type HeadingSectionProps = {
    article: Article
    category?: PartialCategory
    user?: User
    section?: PartialSection
}

export default function HeadingSection({ article, user, category, section }: HeadingSectionProps) {
    const { t } = useTranslation('helpcenter')
    const items = []
    if (category) {
        items.push({ text: category.name, href: category.href })
    }
    if (section) {
        const sectionName = section.id === 0 ? t('allIntegrations') : section.name
        items.push({ text: sectionName, href: section.href })
    }
    return (
        <Container width="base">
            {items.length > 0 && <Breadcrumbs items={items} />}
            <Heading level="1" size="major-xl" className="mbs-48 lg-mbs-32 mbe-24 lg-mbe-32">
                {article.title}
            </Heading>
            {canDisplayMetaInfo(article) && (
                <Hidden above="lg">
                    <MetaInfo className="mbe-24" user={user} article={article} />
                </Hidden>
            )}
            <Divider />
        </Container>
    )
}
